export enum PredefinedRole {
	DEALER = 'Dealer',
	FLEET_MANAGER = 'Fleet Manager',
	DRIVER = 'Driver',
	CHARGING_PARTNER = 'Charging Partner',
	FACILITY_MANAGER = 'Facility Manager',
}
